module.exports = __webpack_public_path__ + "static/media/IMG_20191204_124402.1289a0a7.jpg";